module.exports = __webpack_public_path__ + "static/media/create-feature-hearing.c52e31fe.svg";